// extracted by mini-css-extract-plugin
export default {"partnerLogo":"Partner_partnerLogo__R0Z0w","partnerContainer":"Partner_partnerContainer__ri78w"};